import genericContentItemAnswer from '@shared/components/mixins/genericContentItemAnswer'

export default {
  name: 'RankComponent',
  mixins: [genericContentItemAnswer],
  props: {
    component: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      value: 0,
      colors: [
        this.component.styling.startColor,
        this.component.styling.middleColor,
        this.component.styling.endColor,
      ],
      pointerAtLeftHalf: true,
      currentValue: this.value,
      hoverIndex: -1,
      disabledVoidColor: '#EFF2F7',
    }
  },
  computed: {
    iconCount: function() {
      return this.component.settings.type !== 'number'
        ? this.component.settings.count
        : this.component.settings.count + 1
    },
    voidIconClass: function() {
      return 'icon-' + this.component.settings.type
    },
    disabledVoidIconClass: function() {
      return 'icon-' + this.component.settings.type + '-full'
    },
    iconClasses: function() {
      let icons
      if (this.component.settings.type === 'smile') {
        icons = ['icon-sad-full', 'icon-smile-full', 'icon-cool-full']
      } else {
        icons = [
          'icon-' + this.component.settings.type + '-full',
          'icon-' + this.component.settings.type + '-full',
          'icon-' + this.component.settings.type + '-full',
        ]
      }

      return icons
    },
    lowThreshold: function() {
      const count = this.component.settings.count
      let threshold = 2

      if (count > 5) {
        threshold = 4
      } else if (count < 5) {
        threshold = 1
      }

      return threshold
    },
    highThreshold: function() {
      const count = this.component.settings.count
      let threshold = 4

      if (count > 5) {
        threshold = 8
      } else if (count < 5) {
        threshold = 3
      }

      return threshold
    },
    voidClass: function() {
      return this.rateDisabled ? this.classMap.disabledVoidClass : this.classMap.voidClass
    },
    activeClass: function() {
      return this.getValueFromMap(this.currentValue, this.classMap)
    },
    colorMap: function() {
      return {
        lowColor: this.colors[0],
        mediumColor: this.colors[1],
        highColor: this.colors[2],
        voidColor: this.component.styling.baseColor,
        disabledVoidColor: this.disabledVoidColor,
      }
    },
    activeColor: function() {
      return this.getValueFromMap(this.currentValue, this.colorMap)
    },
    classes: function() {
      const result = []
      let i = 0
      const threshold = this.currentValue

      for (; i < threshold; i++) {
        result.push(this.activeClass)
      }
      for (; i < this.component.settings.count; i++) {
        result.push(this.voidClass)
      }
      return result
    },
    classMap: function() {
      return {
        lowClass: this.iconClasses[0],
        mediumClass: this.iconClasses[1],
        highClass: this.iconClasses[2],
        voidClass: this.voidIconClass,
        disabledVoidClass: this.disabledVoidIconClass,
      }
    },
    rateDisabled: function() {
      return this.disabled || (this.elForm || {}).disabled
    },
  },
  watch: {
    value(val) {
      this.currentValue = val
      this.pointerAtLeftHalf = this.value !== Math.floor(this.value)
    },
  },
  created() {
    if(this.component.answer) {
      this.selectValue(this.component.answer.value)
    }
  },
  methods: {
    getValueFromMap: function(value, map) {
      let result = ''
      if (value <= this.lowThreshold) {
        result = map.lowColor || map.lowClass
      } else if (value >= this.highThreshold) {
        result = map.highColor || map.highClass
      } else {
        result = map.mediumColor || map.mediumClass
      }
      return result
    },
    getIconStyle: function(item) {
      const voidColor = this.rateDisabled
        ? this.colorMap.disabledVoidColor
        : this.colorMap.voidColor
      return {
        color: item <= this.currentValue ? this.activeColor : voidColor,
      }
    },
    selectValue: function(value) {
      if (this.rateDisabled) {
        return
      }

      this.value = value
      this.triggerInputChange(value)
    },
    handleKey: function(e) {
      if (this.rateDisabled) {
        return
      }
      let currentValue = this.currentValue
      const keyCode = e.keyCode
      if (keyCode === 38 || keyCode === 39) {
        // left / down
        currentValue += 1
        e.stopPropagation()
        e.preventDefault()
      } else if (keyCode === 37 || keyCode === 40) {
        currentValue -= 1
        e.stopPropagation()
        e.preventDefault()
      }
      currentValue = currentValue < 0 ? 0 : currentValue
      currentValue =
        currentValue > this.component.settings.count ? this.component.settings.count : currentValue

      this.triggerInputChange(currentValue)
    },
    setCurrentValue: function(value, event) {
      if (this.rateDisabled) {
        return
      }
      this.currentValue = value
      this.hoverIndex = value
    },
    resetCurrentValue: function() {
      if (this.rateDisabled) {
        return
      }
      this.currentValue = this.value
      this.hoverIndex = -1
    },
    triggerInputChange: function(value) {
      this.answer.value = value
      this.$eventBus.$emit('rank-answer', this.answer)
    },
  },
}
